import ChooseFileFromVault from './my-documents-modal.component.vue';

export { ChooseFileFromVault };
